// src/utils/knowledgeBaseColumnDefs.ts
import { ColDef } from "ag-grid-community";
import { KnowledgeBaseData } from "./KnowledgeBaseTypes";

const isAdmin = localStorage.getItem("isAdmin") === "true";

const getColumnDefs = (
  handleEdit: (data: KnowledgeBaseData) => void,
  handleDelete: (ticketId: string) => void
): ColDef<KnowledgeBaseData>[] => {
  //console.log("isAdminnnnnnnnn", isAdmin);

  const columns: (ColDef<KnowledgeBaseData> | false)[] = [
    {
      field: "ticketId",
      headerName: "Ticket ID",
      filter: "agTextColumnFilter",
    },
    { field: "status", headerName: "Status" },
    {
      field: "knowledgeBaseCrossReference",
      headerName: "Ticket Cross Reference Number",
    },
    { field: "affectedCustomer", headerName: "Customer" },
    { field: "affectedNetwork", headerName: "Network" },
    { field: "affectedSite", headerName: "Site" },
    { field: "affectedLink", headerName: "Link" },
    { field: "asset", headerName: "Asset" },
    { field: "summary", headerName: "Summary" },
    { field: "description", headerName: "Description" },
    { field: "solution", headerName: "Solution" },
    { field: "rootCause", headerName: "Root Cause " },

    {
      field: "ticketCreationDatetime",
      headerName: "Ticket Creation Datetime",
      filter: "agDateColumnFilter",
      valueFormatter: (params: any) => {
        if (!params.value) return "";
        return new Date(params.value).toLocaleString(undefined, {
          timeZoneName: "short",
        });
      },
      filterValueGetter: (params: any) => {
        const raw = params.data?.ticketCreationDatetime;
        return raw ? new Date(raw.replace(" ", "T")) : null;
      },
      sort: "desc",
      sortIndex: 3,
    },
    {
      field: "ticketClosureDatetime",
      headerName: "Ticket Closure Datetime",
      filter: "agDateColumnFilter",
      valueFormatter: (params: any) => {
        if (!params.value) return "";
        return new Date(params.value).toLocaleString(undefined, {
          timeZoneName: "short",
        });
      },
      filterValueGetter: (params: any) => {
        const raw = params.data?.ticketClosureDatetime;
        return raw ? new Date(raw.replace(" ", "T")) : null;
      },
    },
    {
      field: "createdby",
      headerName: "Created By",
      filter: "agMultiColumnFilter",
    },

    {
      field: "closedby",
      headerName: "Closed By",
    },

    {
      field: "relatedobject",
      headerName: "Related Object",
      filter: "agMultiColumnFilter",
    },

    {
      colId: "actions",
      headerName: "Actions",
      cellRenderer: (params: any) => (
        <div style={{ display: "flex", gap: "8px" }}>
          <button onClick={() => handleEdit(params.data)}>Edit</button>
          <button onClick={() => handleDelete(params.data.ticketId)}>
            Delete
          </button>
        </div>
      ),
      pinned: "right",
      flex: 1,
    },
  ];

  return columns.filter(Boolean) as ColDef<KnowledgeBaseData>[];
};

export default getColumnDefs;
